import React from 'react';
import { Link } from 'react-router-dom';
import { arrLeft, linkArrowLeft } from '../../svgs';

import Image from '../imageComponent';
import { NotFoundWrapper } from './styled'

const NotFound:React.FC<any> = ({page, text}) => {
  return (
    <NotFoundWrapper space={page}>
        <div className="hero"><Image src="/images/not-found.png" contain /></div>

        {page ? <p>ისეთ გვერდზე აღმოჩნდი, რომელიც არ იძებნება. 
            არაუშავს, ახლავე დაგაბრუნებთ მთავარ
            გვერდზე</p> : <p>{text}</p> }

        <Link to="/">{linkArrowLeft()}მთავარი</Link>

    </NotFoundWrapper>
  )
};
export default NotFound
